export default __webpack_public_path__ + "static/3-a01ad40733002399562749f8a30a9b38.jpg";